<script setup lang="ts">
    export interface Props {
        message: string;
    }
    defineProps<Props>();
</script>

<template>
    <div class="form-action-notification py-2 px-0 text-warning font-weight-bold">
        <span class="mr-1">{{ message }}</span>
        <v-icon icon="mdi-arrow-right" />
    </div>
</template>

<style scoped>
    .form-action-notification {
        display: flex;
        height: 100%;
    }
</style>
